import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FacturacionService } from '@facturacion/facturacion.service';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { LegajosBusqueda } from '@shared/enums/LegajosBusqueda';
import { Motivo } from '@shared/enums/Motivo';
import { EstadoRefacturacion } from '@shared/enums/estadoRefacturacion';
import { TipoSolicitudRefacturacion } from '@shared/enums/facturacion/TipoSolicitudRefacturacion';
import { TipoDocumento } from '@shared/enums/tipoDocumento';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { ErrorModel } from '@shared/models/ErrorModel';
import { LegajoAuditoria } from '@shared/models/reportes/legajos/LegajoAuditorias';
import { ItemMultiFiltro } from '@shared/multifiltro/ItemMultifiltro';
import { ItemMultifiltroComponent } from '@shared/multifiltro/item-multifiltro/item-multifiltro.component';
import { SharedService } from '@shared/shared.service';
import { MessageService } from '@shell/message.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-legajos-auditorias',
  templateUrl: './legajos-auditorias.component.html',
  styleUrl: './legajos-auditorias.component.scss'
})
export class LegajosAuditoriasComponent implements OnInit {
  busquedaFormControl = new FormControl();

  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;

  minFechaHasta: NgbDateStruct;
  maxFechaHasta: NgbDateStruct;
  cargandoLista: boolean;
  primerLlamado: boolean = false;

  startDate: Date;
  endDate: Date;

  enumLegajosBusqueda = LegajosBusqueda;
  tipoSeleccionado: LegajosBusqueda = LegajosBusqueda.Solicitudes; tiposBusqueda: { key: string; value: number }[] = [];
  legajosFiltrados: LegajoAuditoria[] = [];
  legajosFiltradosMultifiltro: LegajoAuditoria[] = [];
  legajos: LegajoAuditoria[] = [];
  clienteMultiFiltro: ItemMultiFiltro[] = [];
  motivoMultiFiltro: ItemMultiFiltro[] = [];
  tipoSolicitudMultiFiltro: ItemMultiFiltro[] = [];
  estadoMultiFiltro: ItemMultiFiltro[] = [];
  cuentaMultiFiltro: ItemMultiFiltro[] = [];
  legajoMultiFiltro: ItemMultiFiltro[] = [];
  facturaMultiFiltro: ItemMultiFiltro[] = [];
  aerovaleMultiFiltro: ItemMultiFiltro[] = [];
  solicitanteMultiFiltro: ItemMultiFiltro[] = [];
  validacionComercialMultiFiltro: ItemMultiFiltro[] = [];
  validadorFacturacionMultiFiltro: ItemMultiFiltro[] = [];
  aprobadorMultiFiltro: ItemMultiFiltro[] = [];


  constructor(private calendar: NgbCalendar, private spinner: NgxSpinnerService, private facturacionService: FacturacionService,
    private sharedService: SharedService, private messageService: MessageService, private excelService: ExportExcelServiceService) { }

  ngOnInit(): void {
    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();
    this.tiposBusqueda = Object.keys(this.enumLegajosBusqueda)
      .filter(k => !isNaN(Number(this.enumLegajosBusqueda[k]))) // descarta claves duplicadas (inversas)
      .map(k => ({
        key: k,
        value: this.enumLegajosBusqueda[k as keyof typeof LegajosBusqueda]
      }));
  }


  buscarDesdeHasta() {
    const fechaDesde = this.sharedService.formatDate(this.modelDesde.year, this.modelDesde.month, this.modelDesde.day, 0, 0);
    const fechaHasta = this.sharedService.formatDate(this.modelHasta.year, this.modelHasta.month, this.modelHasta.day, 23, 59)
    if(fechaHasta < fechaDesde){
      this.messageService.showErrorMessage('La fecha de inicio no puede ser posterior a la fecha final');
    } else {
      this.primerLlamado = true;
      this.mostrarSpinner();
      this.facturacionService.getLegajosAuditorias(fechaDesde, fechaHasta, this.tipoSeleccionado).subscribe(l => {
      this.legajosFiltrados = l.map(item => ({
        ...item,
        solicitante: item.solicitante
        ? (this.esJSON(item.solicitante) 
            ? this.parsearJSON(item.solicitante) 
            : item.solicitante)
        : null,
        aprobador: item.aprobador
        ? (this.esJSON(item.aprobador) 
            ? this.parsearJSON(item.aprobador) 
            : item.aprobador)
        : null,
        validacionComercial: item.validacionComercial ? this.parsearJSON(item.validacionComercial) : null,
        validadorFacturacion: item.validadorFacturacion ? this.parsearJSON(item.validadorFacturacion) : null
      })).sort((a, b) => Number(a.legajo) - Number(b.legajo));
      this.legajosFiltradosMultifiltro = this.legajosFiltrados;
      this.ocultarSpinner();
    }, (err: ErrorModel) => {
      this.messageService.showErrorMessage(err.message + err.description);
      this.ocultarSpinner();
    })
    }
  }

  recargarItems(nombre: keyof this, nuevos: ItemMultiFiltro[]) {
    (this[nombre] as ItemMultiFiltro[]) = nuevos;
    this.aplicarMultifiltro();
  }

  obtenerEstado(numero: string) {
    return EstadoRefacturacion[numero]
  }

  obtenerMotivo(numero: string) {
    return Motivo[numero]
  }
  
  obtenerTipoSolicitud(numero: number) {
    return TipoSolicitudRefacturacion[numero]
  }
  
  mostrarSpinner() {
    this.spinner.show('spinnerGrafico');
    this.cargandoLista = true;
  }

  ocultarSpinner() {
    this.spinner.hide('spinnerGrafico');
    this.cargandoLista = false;
  }

  formatLabel(key: string): string {
    return key.replace(/_/g, ' ');
  }

  parsearJSON(jsonFirma) {
    if (!jsonFirma) return ""
    const data = JSON.parse(jsonFirma);
    return data.nombresCompletos;
  }

  esJSON(str) {
    try {
        const result = JSON.parse(str);
        return typeof result === 'object' && result !== null;
    } catch (e) {
        return false;
    }
}

  descargarExcel() {
    const arrayLegajos = this.legajosFiltradosMultifiltro.map(s => ({
      'Legajo': s.legajo,
      'Factura': s.factura,
      'Fecha Factura': this.formatFechaHora(s.fechaFactura),
      'Aerovale a modificar': s.aerovale,
      'Aerovales factura': s.aerovalesFactura || '--',
      'Aeroplanta del aerovale que se modifica': s.aeroplanta || '--',
      'Cliente': s.cliente,
      'Cuenta': s.cuenta,
      'Tipo': this.obtenerTipoDocumento(s.tipoDocumento),
      'Documento': s.documento,
      'Motivo': Motivo[s.motivoRefacturacion],
      'Tipo Solicitud': TipoSolicitudRefacturacion[s.tipoSolicitudRefacturacion],
      'Estado': EstadoRefacturacion[s.estado],
      'Notas': s.notaCredito || '--',
      'Solicitante': s.solicitante,
      'Fecha solicitud': this.formatFechaHora(s.fechaSolicitante),
      'Comentario solicitud': s.comentarioSolicitud || '--',
      'Validador comercial': s.validacionComercial,
      'Fecha validador comercial': this.formatFechaHora(s.fechaValidacionComercial),
      'Validador facturación': s.validadorFacturacion,
      'Fecha validador facturacion': this.formatFechaHora(s.fechaValidadorFacturacion),
      'Comentario validador ': s.comentarioRevisor || '--',
      'Aprobador': s.aprobador || '--',
      'Fecha aprobador facturación (fecha de emisión nota de credito)': this.formatFechaHora(s.fechaAprobador),
      'Comentario aprobador': s.comentarioAprobador || '--',
      'Adjunto': s.adjunto ? 'si' : 'no'
    }));
  
    this.excelService.exportAsExcelFile(arrayLegajos, 'LegajosAuditorias');
  }

  obtenerTipoDocumento(tipo) {
    return TipoDocumento[tipo];
  }

  esNotaCredito(nota: string) {
    return nota.startsWith("NC");
  }

  formatFechaHora(fechaStr: string): string {
    if (!fechaStr) return "--"
    const fecha = new Date(fechaStr);
    return this.sharedService.formatDate(
      fecha.getFullYear(),
      fecha.getMonth() + 1,
      fecha.getDate(),
      fecha.getHours(),
      fecha.getMinutes()
    );
  }

  filtrarPorMultifiltros(lista: LegajoAuditoria[], filtroTexto?: string): LegajoAuditoria[] {
    const filtro = (filtroTexto ?? '').toLowerCase().trim();
  
    return lista.filter(s => {
      let mostrar = true;
  
      const checks: [ItemMultiFiltro[], any, boolean?][] = [
        [this.clienteMultiFiltro, s.cliente],
        [this.cuentaMultiFiltro, s.cuenta],
        [this.estadoMultiFiltro, s.estado, true],
        [this.motivoMultiFiltro, s.motivoRefacturacion, true],
        [this.tipoSolicitudMultiFiltro, s.tipoSolicitudRefacturacion, true],
        [this.legajoMultiFiltro, s.legajo],
        [this.facturaMultiFiltro, s.factura],
        [this.aerovaleMultiFiltro, s.aerovale],
        [this.solicitanteMultiFiltro, s.solicitante],
        [this.validacionComercialMultiFiltro, s.validacionComercial],
        [this.validadorFacturacionMultiFiltro, s.validadorFacturacion],
        [this.aprobadorMultiFiltro, s.aprobador]
      ];
  
      for (const [filtroArr, valor, esNumero] of checks) {
        if (filtroArr?.some(e => e.seleccionado)) {
          const valorNormalizado = valor ?? ItemMultifiltroComponent.SIMBOLO_VALOR_NULO;
          mostrar = mostrar && filtroArr.some(e => e.seleccionado &&
            (esNumero ? Number(e.id) === valorNormalizado : e.id === valorNormalizado)
          );
        }
      }
  
      if (!mostrar) return false;
  
      if (filtro) {
        return (
          (s.cliente ?? '').toLowerCase().includes(filtro) ||
          (s.aerovale ?? '').toString().includes(filtro) ||
          (s.factura ?? '').toString().includes(filtro) ||
          (s.legajo ?? '').toString().includes(filtro)
        );
      }
  
      return true;
    });
  }
  
  aplicarMultifiltro() {
    this.legajosFiltradosMultifiltro = this.filtrarPorMultifiltros(this.legajosFiltrados);
  }
  
  filtrarLegajos() {
    const texto = this.busquedaFormControl.value;
    this.legajosFiltradosMultifiltro = this.filtrarPorMultifiltros(this.legajosFiltrados, texto);
  }

  onDesdeChange(): void {
    if (!this.modelDesde || !this.modelHasta) return;
  
    const desde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    const hasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
  
    const max = new Date(desde);
    max.setMonth(max.getMonth() + 1);
  
    this.minFechaHasta = { ...this.modelDesde };
    this.maxFechaHasta = { year: max.getFullYear(), month: max.getMonth() + 1, day: max.getDate() };
  
    if (desde < hasta && hasta > max) {
      this.modelHasta = { ...this.maxFechaHasta };
    }
  }
  
  
  

}
